import { CommonPayNormalLabelIcon, CommonPayNormalNewLabelIcon, MissionGiftIcon } from '@local/assets/icons'

import { MissionCardProps } from '../MissionCard'
import styles from '../MissionCard.module.scss'
import { selectMethodLableMap, selectMethodSummaryLableMap, toShortUnit } from './Reward.helper'

type Props = MissionCardProps['reward'] & {
  step?: number
  summary?: boolean
}

const Reward = ({ name, winnerCount, selectMethod, Icon, step, summary }: Props) => {
  return (
    <div className={styles.benefit_area}>
      <span className={styles.benefit}>
        {Icon === MissionGiftIcon && <Icon className={styles.icon} aria-hidden="true" />}
        {Icon === CommonPayNormalLabelIcon && <Icon className={styles.icon} aria-hidden="true" />}
        {Icon === CommonPayNormalNewLabelIcon && <Icon className={styles.icon_new} aria-hidden="true" />}
        {step && <em>{step}단계 </em>}
        {name}
      </span>
      {winnerCount && `${toShortUnit(winnerCount)}명 `}
      {summary ? selectMethodSummaryLableMap[selectMethod] : selectMethodLableMap[selectMethod]}
    </div>
  )
}

export default Reward
